<template>
  <div class="bank-detail" ref="container">
    <div
      class="item"
      :class="
        bankCard.bankType == 'DC' ? 'item-debit-back' : 'item-credit-back'
      "
    >
      <div class="bank">
        <div class="bank-message">
          <div class="bank-icon"></div>
          <div class="bank-name">
            <div class="consignee">{{ bankCard.bankName }}</div>
            <div>
              {{ bankCard.bankTypeName
              }}<span style="margin-left: 0.2rem;"
                >（<span>{{ bankCard.realName }}</span
                ><span style="margin-left: 0.2rem;">{{ bankCard.phone }}</span
                >）</span
              >
            </div>
          </div>
        </div>
        <div class="item-bank-id">{{ formatterBankId(bankCard.bankId) }}</div>
      </div>
    </div>
    <div class="list">
      <div class="item acea-row row-between-wrapper" key="bank-detail1">
        <div class="name">修改银行预留手机号</div>
        <div class="toEdit">
          <span
            class="iconfont icon-jiantou"
            @click="
              $router.push({ path: '/user/bank_phone?id=' + bankCard.id })
            "
          ></span>
        </div>
      </div>
      <div class="item acea-row row-between-wrapper" key="bank-detail2">
        <div class="name">
          解除绑定
        </div>
        <div class="toEdit">
          <span class="iconfont icon-jiantou" @click="goDelBankCard()"></span>
        </div>
      </div>
    </div>
    <PaymentCode
      @submitPayment="submitPayment"
      @closePayment="closePayment"
      @modifyPayment="modifyPayment"
      :passshow="isOpenPayment"
      :reminder="reminder"
      ref="paymentCode"
    >
    </PaymentCode>
    <PaymentSetWindow
      @close="closePaymentSet"
      v-model="showPaymentSet"
      :type="paymentType"
      :phone="userInfo.phone"
      ref="paymentSet"
    >
    </PaymentSetWindow>
  </div>
</template>

<script>
import { getBankCardDetail, getBankCardRemove, editBankPhone } from "@api/user";
import PaymentCode from "@components/PaymentCode";
import PaymentSetWindow from "@components/PaymentSetWindow";
import { getUserInfo } from "@api/user";
export default {
  name: "BankDetail",
  components: {
    PaymentCode,
    PaymentSetWindow
  },
  data() {
    return {
      bankCard: {},
      id: "",
      isOpenPayment: false,
      reminder: "解绑银行卡，验证身份",
      showPaymentSet: false,
      paymentType: 1,
      userInfo: {}
    };
  },
  mounted: function() {
    let id = this.$route.query.id;
    this.id = id;
    console.log(id);
    this.getDetail();
    this.getuserInfo();
  },
  methods: {
    getDetail: function() {
      let that = this;
      getBankCardDetail(that.id)
        .then(res => {
          that.bankCard = res.data;
        })
        .catch(err => {
          that.$dialog.toast({ mes: err.msg });
          that.$router.replace({ path: "/user/bank_manage" });
        });
    },
    getuserInfo: function() {
      getUserInfo(2).then(res => {
        this.userInfo = res.data;
      });
    },
    formatterBankId(bankId) {
      return `···· ···· ···· ${bankId}`;
    },
    goDelBankCard() {
      if (this.userInfo.set === 2) {
        this.$vantDialog
          .confirm({
            title: "",
            message: "您还未设置支付密码，是否去设置",
            className: "errorPayment",
            confirmButtonText: "去设置",
            confirmButtonColor: "red",
            cancelButtonText: "取消",
            cancelButtonColor: "black"
          })
          .then(() => {
            // this.$router.replace({
            //   path: "/user/paymentset/setPayment"
            // });
            this.paymentType = 1;
            this.showPaymentSet = true;
          })
          .catch(() => {});
        return false;
      }
      //弹出输入支付密码弹框
      this.isOpenPayment = true;
    },
    closePayment() {
      this.isOpenPayment = false;
    },
    modifyPayment() {
      this.isOpenPayment = false;
      this.paymentType = 2;
      this.showPaymentSet = true;
    },
    submitPayment() {
      this.isOpenPayment = false;
      this.delBankCard();
    },
    /**
     * 解绑银行卡
     */
    delBankCard: function() {
      // this.$dialog.confirm({
      // 	mes: '确认解绑该银行卡吗?',
      // 	opts: () => {
      // 		let that = this;
      // 		let id = that.id;
      // 		getBankCardRemove(id).then(function() {
      // 			that.$dialog.toast({
      // 				mes: '解绑成功!',
      // 				callback: () => {
      // 					this.$router.push({ path: '/user/bank_manage' });
      // 				}
      // 			});
      // 		});
      // 	}
      // });
      let that = this;
      let id = that.id;
      getBankCardRemove(id).then(function() {
        that.$dialog.toast({
          mes: "解绑成功!",
          callback: () => {
            that.$router.replace({ path: "/user/bank_manage" });
          }
        });
      });
    },
    closePaymentSet(val) {
      if (val && this.paymentType === 1) {
        this.userInfo.set = 1;
      }
      this.showPaymentSet = false;
    }
  }
};
</script>

<style></style>
